import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { safePersistStorage } from '../shared/utils/safePersistStorage';
import { createBannerSlice } from './slices/strategiesBannerSlice';
import { createThemeSlice } from './slices/themeSlice';
import { createSidebarSlice } from './slices/sideBarSlice';
import { createStrategiesDashboardViewModeSLice } from './slices/strategiesDashboardViewModeSlice';
import type { PreferencesState } from './types/preferencesStoreTypes';

export const usePreferencesStore = create<PreferencesState>()(
  // persist(get, set, store)
  devtools(
    persist(
      immer((...a) => ({
        ...createBannerSlice(...a),
        ...createThemeSlice(...a),
        ...createSidebarSlice(...a),
        ...createStrategiesDashboardViewModeSLice(...a),
      })),
      {
        name: 'app-preferences',
        storage: safePersistStorage('local'),
      },
    ),
    {
      name: 'PreferenceStore',
    },
  ),
);
